module.exports = "<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/user-application/user-application.component.html
// module id = ./src/app/applicant/user-application/user-application.component.html
// module chunks = main